import { errorValidation } from './utils';

let oneClickPhone = $('#one_click_phone');

/**
 * Init intlTelInput
 */
[oneClickPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateOneClickPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// One Click
	$("form[name='one_click']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'one_click[name]': {
				required: true,
			},
			'one_click[phone]': {
				required: true,
				// validateOneClickPhone: true,
			},
			'one_click[city]': {
				required: true,
			},
			'one_click[privacy]': {
				required: true,
			},
		},
		messages: {
			'one_click[name]': {
				required: window.translations.required,
			},
			'one_click[phone]': {
				required: window.translations.required,
			},
			'one_click[city]': {
				required: window.translations.required,
			},
			'one_click[privacy]': {
				required: window.translations.checkboxRequired,
			},
		},
		submitHandler: async (form, e) => {
			if (e) e.preventDefault();

			// Disable submit button
			$(form).find('button[type="submit"]').prop('disabled', true);
			$(form).find('button[type="submit"]').addClass('disabled');

			if (form.hasAttribute('data-recaptcha')) {
				const action = form.getAttribute('data-recaptcha');
				const success = await window.add_recaptcha_token(form, action);

				if (success) {
					console.log('✅ reCAPTCHA token added successfully');
					form.submit();
				} else {
					console.log('❌ reCAPTCHA failed');
				}
			} else {
				console.log('🔄 Form validation passed');
				form.submit();
			}
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
